import { Feature, DrawerService } from '@tencent/workbench';
import BaseToolbarFeature from '@src/framework/workbench/common/feature/base-toolbar-feature';
import type { IAnimPaneFeature } from './anim-pane-interface';
import { config } from './config';
import { IRightSideBarManager } from '@src/slide/application/service/right-side-bar-manager/right-side-bar-manager.interface';
import { isPreviewOnly } from '@src/page/toc/common/check-client-vars';
import { PPTEditorStateEnumType } from '@src/slide/domain/ui-model/constant/edit-state-type';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';
import { DrawerName } from '@framework/workbench/drawer/constants';
import {
    IDrawerStateManager,
} from '@src/slide/application/service/drawer-state-manager/core/drawer-state-manager.interface';

@Feature()
export class AnimPaneFeature extends BaseToolbarFeature implements IAnimPaneFeature {
    public id = config.id;
    public config = config;
    private rightSideBarManager = this.getRightSideBarManager();

    public constructor(private readonly drawerService: DrawerService) {
        super();
    }

    // 动画窗格点击回调
    public onClick() {
        this.rightSideBarManager?.setIsAnimationEditorShown(!this.rightSideBarManager?.isAnimationEditorShown);

        if (!this.rightSideBarManager?.isAnimationEditorShown) {
            (this.getAppService() as IPcEditorAppServices).editableServiceLayer
                ?.drawerStateManager.promise().then((manager) => {
                    if (manager.openedDrawers.length > 1) {
                        manager.closeTab(DrawerName.ANIMATION_RIGHT_DRAWER);
                    } else {
                        manager.closeRightDrawerDirectly([]);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    }

    // 动画tab点击回调
    public handleAnimTabClick() {
        if (isPreviewOnly() || this.rightSideBarManager?.isAnimationEditorShown
        || this.getUserPriviledgeService().pptEditorState !== PPTEditorStateEnumType.EDITABLE) return;
        this.rightSideBarManager?.setIsAnimationEditorShown(true);
    }

    public shouldCheck(): boolean {
        return !!this.getRightSideBarManager()?.isAnimationEditorShown;
    }

    private getRightSideBarManager(): IRightSideBarManager | undefined {
        return this.getAppService().editableServiceLayer?.rightSideBarManager;
    }
}
